import {
  Answer,
  Container,
  GridContainer,
  QnaSection,
  Question,
} from "./ContentBlock.style";

type QnABlockData = {
  heading: string;
  description: string;
};

type ContentBlockProps = {
  data?: QnABlockData[];
};

const ContentBlock = ({ data }: ContentBlockProps) => {
  const qnaData = data || []; // || LOCAL_CONTENT_BLOCK_INFO;

  return (
    <Container>
      <GridContainer>
        {qnaData?.map((item, index) => (
          <QnaSection key={index} index={index}>
            <Question>{item?.heading}</Question>
            <Answer>{item?.description}</Answer>
          </QnaSection>
        ))}
      </GridContainer>
    </Container>
  );
};

export default ContentBlock;
